var render = function render(){var _vm=this,_c=_vm._self._c;return _c('filter-bar',[_c('div',{staticClass:"md-layout-item md-size-20 md-medium-size-50 md-small-size-50 md-xsmall-size-100"},[_c('md-field',[_c('label',[_vm._v("Almacén")]),_vm._v(" "),_c('md-select',{model:{value:(_vm.selectedWarehouse),callback:function ($$v) {_vm.selectedWarehouse=$$v},expression:"selectedWarehouse"}},_vm._l((_vm.fetchedWarehouses),function(camp){return _c('md-option',{key:camp.id,attrs:{"value":camp.id}},[_vm._v(_vm._s(camp.name))])}),1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/pages/Reports/InventoryLog/Filter.vue